import NodeModule from '../../services/NodeModule';
import Form from './views/Form';
import UserDataEmailFormValidator from './views/UserDataEmailFormValidator';

export default class UserDataEmailNode extends NodeModule {
  start(options) {
    console.log('Starting User Data Email');
    const userDataEmail = new Form({el: options.el, formEl: '#userForm', type: (opts) => new UserDataEmailFormValidator(opts)});
  }
}